// extracted by mini-css-extract-plugin
export default {"board_wrapper":"CardCustomBoardItem_board_wrapper__jPXuX","web_board_wrapper":"CardCustomBoardItem_web_board_wrapper__cauGN"};